module.exports = __webpack_public_path__ + "img/91407.fbab9818.svg";